// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EditNicheModal {
  width: 350px;
}
.EditNicheModal [class^=dist_TabsWrapper] {
  margin-bottom: 12px;
}`, "",{"version":3,"sources":["webpack://./src/modules/niche/edit-niche-modal/edit-niche-modal.styles.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;AACF;AACE;EACE,mBAAA;AACJ","sourcesContent":[".EditNicheModal {\n  width: 350px;\n\n  [class^='dist_TabsWrapper'] {\n    margin-bottom: 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
